import styled, {css} from "styled-components";
import {Link} from "react-router-dom";

export const Row = styled.div`
  &::after {
    content: "";
    clear: both;
    display: table;
  }
`

interface ColProps {
    xl?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
    lg?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
    md?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
    sm?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
    xs?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
    xlOffset?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
    lgOffset?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
    xsOffset?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
}

const calcWidth = value => value / 12 * 100;

export const Col = styled.div<ColProps>`
  float: left;
  width: 100%;

  @media only screen and (${({theme}) => theme.media.extraSmall}) {
    width: ${({xs = 12}) => xs / 12 * 100 }%;
    margin-left: ${({xsOffset}) => xsOffset ? xsOffset / 12 * 100 : 0}%;
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    width: ${({sm = 12}) => sm / 12 * 100 }%;
    margin-left: ${({xsOffset}) => xsOffset ? xsOffset / 12 * 100 : 0}%;
  }

  @media only screen and (${({theme}) => theme.media.medium}) {
    width: ${({md = 12}) => md / 12 * 100 }%;
    margin-left: ${({xsOffset}) => xsOffset ? xsOffset / 12 * 100 : 0}%;
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    width: ${({lg = 12}) => lg / 12 * 100 }%;
    margin-left: ${({lgOffset}) => lgOffset ? lgOffset / 12 * 100 : 0}%;
  }

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    width: ${({xl = 12}) => calcWidth(xl) }%;
    margin-left: ${({xlOffset = 0}) => calcWidth(xlOffset) }%;
  }
`

export const Title = styled.span`
  font-size: 25px;
  text-align: center;
  color: ${({theme}) => theme.colors.black};

  @media only screen and (min-width: 992px) {
    text-align: left;
    font-size: 42px;
    margin-bottom: 2rem;
  }
`

export const Title1 = styled.h1`
  color: ${({theme}) => theme.colors.primaryFont};
  font-family: ${({theme}) => theme.font.family};
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  font-style: normal;
  letter-spacing: 0;
  text-align: left;
  text-transform: uppercase;

  @media only screen and (${({theme}) => theme.media.small}) {
    line-height: normal;
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
  }
`

export const Title2 = styled.h3`
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.font.family};
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
`

export const Title3 = styled.h5`
  color: ${({theme}) => theme.colors.primaryFont};
  font-family: ${({theme}) => theme.font.family};
  font-style: normal;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px; 
  text-transform: uppercase;

  @media only screen and (${({theme}) => theme.media.small}) {
    font-size: 24px;
    font-weight: 600;
    line-height: 60px;
  }
`

export const Text1 = styled.span`
  color: ${({theme}) => theme.colors.primaryFont};
  font-family: ${({theme}) => theme.font.family};
  font-style: normal;
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;

  @media only screen and (${({theme}) => theme.media.small}) {
    font-size: 24px;
    font-weight: 400;
    line-height: 60px;
  }
`

export const Uppercase = styled.span`
    text-transform: uppercase;
`

export const Container = styled.div`
  padding: 0;
  margin-bottom: 10vh;
  height: 100%;

  @media only screen and (${({theme}) => theme.media.small}) {
    padding: 0 10px;
  }
  
  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    padding: 0 12%;
  }
`

export const Card = styled.div`
  background: ${({theme}) => theme.colors.secondaryBackground};
  border: none;
  border-radius: 0;
  padding: 20px;

  @media only screen and (${({theme}) => theme.media.small}) {
    border-radius: 40px;
    padding: 80px 100px;
    ${({theme}) => css`border: 1px solid ${theme.colors.cardBorderColor}`};
  }
`

export const CardTitle = styled.div`
  font-family: ${({theme}) => theme.font.family};
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 30px;
  text-transform: uppercase;
  color: ${({theme}) => theme.colors.secondaryFont};

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    font-size: 30px;
    line-height: 40px;
  }

  @media only screen and (min-width: 1600px) {
    font-size: 40px;
    line-height: 54px;
  }
`

export const CardText = styled.div`
  /* color: #3D3136;
   font-size: calc(0.3rem + 1vw);
   line-height: calc(1.5rem + 1vw);*/

  font-family: ${({theme}) => theme.font.family};
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;

  color: ${({theme}) => theme.colors.secondaryFont};

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    font-size: 20px;
    line-height: 40px;
  }

  @media only screen and (min-width: 1600px) {
    font-size: 24px;
    line-height: 50px;
  }
`

export const Module = styled.div`
  height: inherit;
  background-color: ${({theme}) => theme.colors.secondaryBackground};
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 40px;
  padding: 3rem 5rem;
`

export const InnerLink = styled(Link)`
  color: ${({theme}) => theme.colors.red};

  &:hover {
    color: ${({theme}) => theme.colors.darkRed};
    text-decoration-line: underline;
  }
`

export const OuterLink = styled.a`
  color: ${({theme}) => theme.colors.red};

  &:hover {
    color: ${({theme}) => theme.colors.darkRed};
    text-decoration-line: underline;
  }
`